import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type {
  CreateQuotePayload,
  CreateQuoteResponse,
} from '@/services/quotes/types';
import { useMutation } from '@tanstack/react-query';

export function useCreateCapitalGlobalQuote() {
  return useMutation<
    { success: boolean; data?: CreateQuoteResponse; error?: string },
    Error,
    CreateQuotePayload
  >({
    mutationKey: ['quotes', 'create', 'capital-global'],
    mutationFn: async (payload: CreateQuotePayload) => {
      const response = await capitalGlobalQuotesService.createQuote(payload);
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
  });
}
